export class UserAuth {
	id: number;
	username: string;
	password: string;
	nombreCompleto: string;
	email: string;
	roles: string[] = [];
	permisos: string[] = [];
	idUnidad: number;
}